export function getStaffInviteBodyFromUserContact(contact, clinicBrandId) {
  return {
    apiParam: 'staff-invitation-request',
    name: contact?.title,
    role: contact?.role,
    whatsAppId: contact?.mobile,
    email: contact?.email,
    requestStatus: 'pending',
    clinicBrandId: clinicBrandId,
  }
}
